import Button from '@atoms/Button';
import Text from '@atoms/Text';
import TextField from '@atoms/TextField';
import { useTranslationState } from '@i18n/TranslationProvider';
import { createSignal, type Component } from 'solid-js';

export interface SessionEndModalProps {
    onCancel: () => void;
    onEndSessionPressed: (sessionName: string) => void;
}

const SessionEndModal: Component<SessionEndModalProps> = (props) => {
    const t = useTranslationState().t;
    const [sessionName, setSessionName] = createSignal('');
    return (
        <div class="p-6 bg-table-row rounded-xl">
            <p class="text-3xl font-semibold text-secondary-white pr-12 pb-4">
                {t('sessionEndModal.header')}
            </p>
            <div class="mt-4 grid-cols-2 grid-rows-1 grid gap-6">
                <Button variant="secondary" onClick={props.onCancel}>
                    {t('generic.cancel')}
                </Button>
                <Button
                    variant="primary"
                    onClick={() => props.onEndSessionPressed(sessionName())}
                >
                    {t('sessionEndModal.endSessionButton')}
                </Button>
            </div>
        </div>
    );
};

export default SessionEndModal;
